import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const token = sessionStorage.getItem('token')
export const fetchposts = createAsyncThunk(
  "posts/fetchposts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://ssl.vipwellness-suite.de/api/categories");
      return response.data; // تأكد أن البيانات تُرجع مصفوفة الكتاغوري
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


  const initialState = { records: [], Loading: false, erorr: null, reco: [] };

  const PostSlice = createSlice({
    name: "posts",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
  
      // fechposts
  
      builder.addCase(fetchposts.pending, (state, action) => {
        state.Loading = true;
        state.erorr = null;
      });
      builder.addCase(fetchposts.fulfilled, (state, action) => {
        state.Loading = false;
        state.records = action.payload.categories;
      });
      builder.addCase(fetchposts.rejected, (state, action) => {
        state.Loading = false;
        state.erorr = action.payload;
      });
    },
  });

  export default PostSlice.reducer;
  export const fetchAvailableDays = createAsyncThunk(
    "calender/fetchAvailableDays",
    async ({ startTime, endTime,selectedDauer }, thunkApi) => { 
      const { rejectWithValue } = thunkApi;
      try {
        const res = await axios.get(
          `https://ssl.vipwellness-suite.de/api/orders/available-days?startTime=${startTime}&endTime=${endTime}&requiredHours=${selectedDauer}`
        );
        return res.data;
      } catch (error) {
        console.error("Error fetching available days:", error);
        return rejectWithValue(error.message);
      }
    }
  );
